/**
 * Adapter that creates AudioContext objects depending on the browser.
 */
export function createAudioContext(options?: AudioContextOptions): AudioContext | undefined {
    const AudioContextImpl = window.AudioContext || (window as any).webkitAudioContext;

    if (!AudioContextImpl) {
        return undefined;
    }

    return new AudioContextImpl(options);
}

/**
 * Fischer-Yates shuffle algorithm
 * @see https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 */
export function shuffleArray<T>(array: T[]): T[] {
    const shuffled: T[] = [];
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i

        // swap elements array[i] and array[j]
        // we use "destructuring assignment" syntax to achieve that
        // you'll find more details about that syntax in later chapters
        // same can be written as:
        // let t = array[i]; array[i] = array[j]; array[j] = t
        [shuffled[i], shuffled[j]] = [array[j], array[i]];
    }
    return shuffled;
}
